module.exports = __webpack_public_path__ + "img/introduce-icon3.1a8d5929.svg";